import * as types from '../actions/action-types';

const pageMessageReducer = (state = {toggleFocus: false}, action) => {
  switch (action.type) {
    case types.SET_PAGE_MESSAGE:
      return {
        message: action.message,
        messageType: action.messageType,
        toggleFocus: !state.toggleFocus,
      };
    case types.REMOVE_PAGE_MESSAGE:
      return {};
    default:
      return state;
  }
};

export default pageMessageReducer;
